// Auth
export const ADD_USERS = "ADD_USERS";
export const USER_LOGIN = "USER_LOGIN";
export const USER_FORGOT = "USER_FORGOT";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_OTPVERIFY = "USER_OTPVERIFY";
export const USER_UPDATEPASSWORD = "USER_UPDATEPASSWORD";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const TOKEN_GENRATE = "TOKEN_GENRATE";
export const REMOVE_FORGOT_DATA = "REMOVE_FORGOT_DATA";
export const SAVE_FORGOT_DATA = "SAVE_FORGOT_DATA";
export const USER_CHANGEPASSWORD = "USER_CHANGEPASSWORD";
export const FIREBASE_UPDATE = "FIREBASE_UPDATE";

// Permission Module
export const PERMISSION_MODULES = "PERMISSION_MODULES";
export const PERMISSION_MODULES_DEFAULT = "PERMISSION_MODULES_DEFAULT";

// Dashboard_Detail_Admin
export const DASHBOARD_DETAIL_ADMIN = "DASHBOARD_DETAIL_ADMIN";
export const DASHBOARD_GRAPH = "DASHBOARD_GRAPH";
export const DASHBOARD_SOURCING = "DASHBOARD_SOURCING";
export const DASHBOARD_CLOSING = "DASHBOARD_CLOSING";
export const DASHBOARD_SITEHEAD = "DASHBOARD_SITEHEAD";
export const DASHBOARD_SCM = "DASHBOARD_SCM";
export const DASHBOARD_POSTSALE ="DASHBOARD_POSTSALE";
export const DASHBOARD_RECEIPTIONIST ="DASHBOARD_RECEIPTIONIST";

// User Manage
export const GET_USERS = "GET_USERS";
export const REGISTER_ADD_USERS = "REGISTER_ADD_USERS";
export const REGISTER_ADD_ERROR = "REGISTER_ADD_ERROR";
export const USERS_ERROR = "USERS_ERROR";
export const USER_LIST = "USER_LIST";
export const USER_DETAIL = "USER_DETAIL";
export const USER_FILTERDETAIL = "USER_FILTERDETAIL";
export const EDIT_USER = "EDIT_USER";
export const USERSTATUS_UPDATE = "USERSTATUS_UPDATE";
export const USER_ROLE_AND_PARENT_CHANGE = "USER_ROLE_AND_PARENT_CHANGE";
export const GET_PARENT_USERLIST = "GET_PARENT_USERLIST";
export const USER_DETAILS_FOR_VISITOR = "USER_DETAILS_FOR_VISITOR";

// EDIT_USER_PROFILE_UPDATE
export const USER_PROFILE_UPDATE = "USER_PROFILE_UPDATE";
export const GET_USER_PROFILE = "GET_USER_PROFILE";

// MASTER
export const CREATE_MASTER = "CREATE_MASTER";
export const GET_AMENITY = "GET_AMENITY";
export const GET_FOLLOWUP_STATUS = "GET_FOLLOWUP_STATUS";
export const GET_CONFIGURATION = "GET_CONFIGURATION";
export const GET_PROPERTY_TYPE = "GET_PROPERTY_TYPE";
export const GET_INSENTIVE_TYPE = "GET_INSENTIVE_TYPE";
export const MASTER_LIST = "MASTER_LIST";
export const CITY_LIST = "CITY_LIST";
export const MASTER_ERROR = "MASTER_ERROR";
export const PAYMENT_TYPE = "PAYMENT_TYPE";
export const GET_ETHNICITY = "GET_ETHNICITY";

// ROLE
export const GET_ROLE = "GET_ROLE";
export const GET_MODULE = "GET_MODULE";
export const MODULE_ERROR = "MODULE_ERROR";
export const CREATE_MODULE = "CREATE_MODULE";
export const ROLE_MODULES = "ROLE_MODULES";
export const CREATE_ROLE = "CREATE_ROLE";
export const ROLE_DETAIL = "ROLE_DETAIL";
export const ROLE_ERROR = "ROLE_ERROR";

// PROPERTY
export const PROPERTY_FORM = "PROPERTY_FORM";
export const PROPERTY_FORM_UPDATE = "PROPERTY_FORM_UPDATE";
export const PROPERTY_CHECK = "PROPERTY_CHECK";
export const ADD_PROPERTY = "ADD_PROPERTY";
export const PROPERTY_LIST = "PROPERTY_LIST";
export const PROPERTY_EDIT = "PROPERTY_EDIT";
export const GETPROPERTY_DETAIL = "GETPROPERTY_DETAIL";
export const PROPERTY_FILTER_LIST = "PROPERTY_FILTER_LIST";
export const PROPERTY_STATUS_UPDATE = "PROPERTY_STATUS_UPDATE";
export const PROPERTY_ERROR = "PROPERTY_ERROR";
export const PROPERTY_CONFIGURATION_LIST = "PROPERTY_CONFIGURATION_LIST";
export const PROPERTY_DOCUMENT_DELETE = "PROPERTY_DOCUMENT_DELETE";
export const SYNC_ALL_PROJECTS = "SYNC_ALL_PROJECTS";

// FOLLOWUP
export const GET_FOLLOWUP = "GET_FOLLOWUP";
export const FOLLOWUP_ERROR = "FOLLOWUP_ERROR";
export const FOLLOWUP_LIST = "FOLLOWUP_LIST";
export const GETFOLLOWUP_DETAIL = "GETFOLLOWUP_DETAIL";
export const UPDATEFOLLOWUP = "UPDATEFOLLOWUP";
export const GET_LEAD_TYPE = "GET_LEAD_TYPE";
export const GET_SITEVISIT_TYPE = "GET_SITEVISIT_TYPE";
export const GET_BOOKING_TYPE = "GET_BOOKING_TYPE";
export const GET_REGISTRAION_TYPE = "GET_REGISTRAION_TYPE";
export const UPDATE_STATUS = "UPDATE_STATUS";
export const ADD_FOLLOWUP = "ADD_FOLLOWUP";
//Scheduled followp activity
export const SCHEDULED_FOLLOWUP_ACTIVITY = "SCHEDULED_FOLLOWUP_ACTIVITY"
export const MARK_SCHEDULED_FOLLOWUP = "MARK_SCHEDULED_FOLLOWUP"

// CHANNELPARTER
export const CHANNEL_PARTNER_ERROR = "CHANNEL_PARTNER_ERROR";
export const CHANNEL_PARTNER_LIST = "CHANNEL_PARTNER_LIST";
export const CHANNEL_PARTNER_DETAIL = "CHANNEL_PARTNER_DETAIL";
export const CHANNEL_PARTNER_FILTER = "CHANNEL_PARTNER_FILTER";
export const CHANNEL_PARTNER_STATUS = "CHANNEL_PARTNER_STATUS";
export const ADD_CHANNEL_PARTNER = "ADD_CHANNEL_PARTNER";
export const GET_SM_LIST = "GET_SM_LIST";
export const CHECK_EMAIL_MOBILE = "CHECK_EMAIL_MOBILE";
export const CP_CURRENT_MAPING = "CP_CURRENT_MAPING";
export const CHANNEL_PARTNER_APPROVE = "CHANNEL_PARTNER_APPROVE";
export const ADD_CP_TO_BUCKET = "ADD_CP_TO_BUCKET"
export const REMOVE_BUCKETDATA = "REMOVE_BUCKETDATA"
export const REMOVE_CHECK_EMAIL_MOBILE = "REMOVE_CHECK_EMAIL_MOBILE"
export const UPDATE_CHANNEL_PARTNER = "UPDATE_CHANNEL_PARTNER"
export const CP_LIST_FOR_SM ="CP_LIST_FOR_SM"
export const CHANNEL_PARTNER_SM="CHANNEL_PARTNER_SM"
// VISITOR
export const VISITOR_ERROR = "VISITOR_ERROR";
export const VISITOR_LIST = "VISITOR_LIST";
export const VISITOR_DETAIL = "VISITOR_DETAIL";
export const EDIT_VISITOR = "EDIT_VISITOR";
export const ADD_VISITOR = "ADD_VISITOR";
export const VISITOR_FORM = "VISITOR_FORM";
export const VISITOR_FORM_UPDATE = "VISITOR_FORM_UPDATE";
export const BULK_IMAGE_UPLOAD = "BULK_IMAGE_UPLOAD";
export const BULK_CSV_UPLOAD = "BULK_CSV_UPLOAD";
export const VISITOR_MOBILE_CHECK = "VISITOR_MOBILE_CHECK";
export const REMOVE_VISITOR_MOBILE_CHECK = "REMOVE_VISITOR_MOBILE_CHECK";
export const VISITOR_LISTS ="VISITOR_LISTS";
export const CHECK_REFERENCE_EXIST = "CHECK_REFERENCE_EXIST"


// NEW_UPLOAD
export const BULK_VISITOR_LIST = "BULK_VISITOR_LIST";
export const BULK_VISITOR_DETAIL = "BULK_VISITOR_DETAIL";
export const BULK_VISIT_FORM = "BULK_VISIT_FORM";

// VERIFY_LEAD
export const BULK_VERIFY_VISITOR_LIST = "BULK_VERIFY_VISITOR_LIST";
export const VISITOR_STATUS_UPDATE = "VISITOR_STATUS_UPDATE";
export const VERIFY_VISITOR_DETAIL = "VERIFY_VISITOR_DETAIL";
export const BULK_VERIFY_VISIT_FORM = "BULK_VERIFY_VISIT_FORM";
export const EDIT_UNVERIFYCSV_VISIT = "EDIT_UNVERIFYCSV_VISIT";

// CONFIGURATION_SETTING
export const CONFIGURATION_SETTING_ERROR = "CONFIGURATION_SETTING_ERROR";
export const GET_CONFIGURATION_SETTING_DETAIL =
  "GET_CONFIGURATION_SETTING_DETAIL";
export const UPDATE_SETTING_DETAIL = "UPDATE_SETTING_DETAIL";

// APPOINTMENT
export const GET_APPOINTMENT_LIST = "GET_APPOINTMENT_LIST";
export const GET_SITE_LEAD_VISIT = "GET_SITE_LEAD_VISIT";
export const GET_CLIENT_VISIT = "GET_CLIENT_VISIT";
export const GET_PANDING_STATUS = "GET_PANDING_STATUS";
export const GET_CONFIRM_STATUS = "GET_CONFIRM_STATUS";
export const GET_COMPLETE_STATUS = "GET_COMPLETE_STATUS";
export const GET_APPOINTMENT_DETAIL = "GET_APPOINTMENT_DETAIL";
export const EDIT_APPOINTMENT = "EDIT_APPOINTMENT";
export const APPOINTMENT_FORM = "APPOINTMENT_FORM";
export const APPOINTMENT_FORM_UPDATE = "APPOINTMENT_FORM_UPDATE";
export const APPOINTMENT_ERROR = "APPOINTMENT_ERROR";
export const GET_VISITOR_LIST = "GET_VISITOR_LIST";
export const ADD_APPOINTMENT = "ADD_APPOINTMENT";
export const GET_APPOINTMENT_LIST_ADMIN = "GET_APPOINTMENT_LIST_ADMIN";
export const CHECKIN_APPOINTMENT = "CHECKIN_APPOINTMENT"
export const CLOSE_APPOINTMENT = "CLOSE_APPOINTMENT"
export const ALLOCATE_CLOSING_MANAGER = "ALLOCATE_CLOSING_MANAGER"

// SUPPORT FORUM
export const GET_SUPPORTFORUM_LIST = "GET_SUPPORTFORUM_LIST";
export const SUPPORTFORUM_STATUS_UPDATE = "SUPPORTFORUM_STATUS_UPDATE";
export const ADD_SUPPORT_FORUM = "ADD_SUPPORT_FORUM";
export const EDIT_SUPPORT_FORUM = "EDIT_SUPPORT_FORUM";
export const SUPPORT_FORUM_DETAIL = "SUPPORT_FORUM_DETAIL";

// RAISE TICKET(SUPPORT)
export const GET_RAISETICKET_LIST = "GET_RAISETICKET_LIST";
export const GET_RAISETICKET_DETAIL = "GET_RAISETICKET_DETAIL";
export const UPDATE_RAISE_TICKET = "UPDATE_RAISE_TICKET";
export const UPDATE_RAISE_TICKET_STATUS = "UPDATE_RAISE_TICKET_STATUS";
export const REPLY_SUPPORT_TICKET = "REPLY_SUPPORT_TICKET";
export const ADD_RAISE_TICKET = "ADD_RAISE_TICKET";

// PRIVACY POLICY
export const GET_PRIVACY_POLICY = "GET_PRIVACY_POLICY";
export const UPDATE_PRIVACY_POLICY = "UPDATE_PRIVACY_POLICY";

// BOOKING

export const GET_BOOKING_LIST = "GET_BOOKING_LIST";
export const GET_BOOKING_DETAILS = "GET_BOOKING_DETAILS";
export const ADD_BOOKING = "ADD_BOOKING";
export const REMOVE_ADD_BOOKING = "REMOVE_ADD_BOOKING"
// REGISTRATION

export const GET_REGISTRATION_LIST = "GET_REGISTRATION_LIST";
export const GET__REGISTRATION_DETAILS = "GET__REGISTRATION_DETAILS";

// Chat Module
export const CHAT_USER_LIST = "CHAT_USER_LIST";
export const CHAT_USER_LIST_SEARCH = "CHAT_USER_LIST_SEARCH";
export const GET_RECENT_CHAT_LIST = "GET_RECENT_CHAT_LIST";
export const UPDATE_CHAT_STATUS = "UPDATE_CHAT_STATUS";
export const GET_USER_CHAT = "GET_USER_CHAT";
export const GET_ACTIVE_PROPERTY_LIST = "GET_ACTIVE_PROPERTY_LIST";

//  report
export const GET_CONVERSION_FUNNEL_REPORT = "GET_CONVERSION_FUNNEL_REPORT";
export const GET_TEAM_PERFORMANCE_REPORT = "GET_TEAM_PERFORMANCE_REPORT";
export const GET_TEAM_CP_PERFORMANCE_REPORT = "GET_TEAM_CP_PERFORMANCE_REPORT";
export const GET_REPORT_PROPERTY_LIST = "GET_REPORT_PROPERTY_LIST";
export const GET_REPORT_EMPLOYEE_LIST = "GET_REPORT_EMPLOYEE_LIST";
export const GET_REPORT_CPNAME_LIST = "GET_REPORT_CPNAME_LIST";
export const MONTHLY_PROPERTY_REPORT = "MONTHLY_PROPERTY_REPORT";
export const USER_ACTIVITY_REPORT = "USER_ACTIVITY_REPORT";
export const GET_PDR_REPORT ="GET_PDR_REPORT"
export const GET_ST_REPORT ="GET_ST_REPORT"
export const GET_CT_REPORT ="GET_CT_REPORT"
export const GET_CM_REPORT ="GET_CM_REPORT"
export const GET_SM_REPORT ="GET_SM_REPORT"
export const GET_SCM_REPORT ="GET_SCM_REPORT"
export const GET_SRCH_REPORT ="GET_SRCH_REPORT"
export const GET_SHCH_REPORT ="GET_SHCH_REPORT"
export const GET_BM_REPORT ="GET_BM_REPORT"
// User Announcement
export const USER_ANNOUNCEMENT = "USER_ANNOUNCEMENT";

//Web report
export const ROLEWISE_PROJECT_REPORT = "ROLEWISE_PROJECT_REPORT";
export const GET_ROLEWISE_PROJECT_REPORT_REQUEST = "GET_ROLEWISE_PROJECT_REPORT_REQUEST";
export const GET_ROLEWISE_PROJECT_REPORT_SUCCESS = "GET_ROLEWISE_PROJECT_REPORT_SUCCESS";
export const GET_ROLEWISE_PROJECT_REPORT_FAILURE = "GET_ROLEWISE_PROJECT_REPORT_FAILURE";
export const PROJECT_DETAILS_REPORT = "PROJECT_DETAILS_REPORT"
export const PROJECT_DETAILS_REPORT_REQUEST = "PROJECT_DETAILS_REPORT_REQUEST"
export const PROJECT_DETAILS_REPORT_SUCCESS = "PROJECT_DETAILS_REPORT_SUCCESS"
export const PROJECT_DETAILS_REPORT_FAILURE = "PROJECT_DETAILS_REPORT_FAILURE"
export const DEPOSITION_REPORT= "DEPOSITION_REPORT"
export const CHANELPARTNER_REPORT= "CHANELPARTNER_REPORT"

//new dashboard
export const NEW_DASHBOARD_DETAILS = "NEW_DASHBOARD_DETAILS"


//company
export const COMPANY_LIST = 'COMPANY_LIST';
export const COMPANY_EMPLOYEE_LIST = 'COMPANY_EMPLOYEE_LIST';
export const COMPANY_LIST_ERROR = 'COMPANY_LIST_ERROR';
export const COMPANY_EMPLOYEE_LIST_ERROR = 'COMPANY_EMPLOYEE_LIST_ERROR';

export const CLOSING_MANAGER_LIST = "CLOSING_MANAGER_LIST"
export const CLOSING_MANAGER_DETAILS = "CLOSING_MANAGER_DETAILS"

export const SOURCING_MANAGER_LIST = "SOURCING_MANAGER_LIST"
export const SOURCING_MANAGER_DETAILS = "SOURCING_MANAGER_DETAILS"

export const USER_APPOINTMENT_LIST = "USER_APPOINTMENT_LIST"
export const USER_APPOINTMENT_STATUS_UPDATE ="USER_APPOINTMENT_STATUS_UPDATE"
export const CREATE_USER_APPOINTMENT = "CREATE_USER_APPOINTMENT"
export const EDIT_USER_APPOINTMENT = "EDIT_USER_APPOINTMENT"

export const USER_APPOINTMENT_LIST_FOR_ADMIN = "USER_APPOINTMENT_LIST_FOR_ADMIN"

// SITE VISIT (LMS Integration)
export const TRIGGER_WEBHOOK = "TRIGGER_WEBHOOK";
export const TRIGGER_WEBHOOK_SUCCESS = "TRIGGER_WEBHOOK_SUCCESS";
export const TRIGGER_WEBHOOK_ERROR = "TRIGGER_WEBHOOK_ERROR";
export const GET_SITE_VISIT_STATUS_DATA = "GET_SITE_VISIT_STATUS_DATA";
export const UPDATE_SITE_VISIT_STATUS = "UPDATE_SITE_VISIT_STATUS";
